import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

import { isAuthenticated } from '../utils/AuthorizationCheck';

// Import app configuration for company details
import { appConfig } from '../config/app.js';

const Contact = ({auth}) => {      
    
    const history = useHistory();
    
    // Authorization guard - allow authenticated users to access contact
    useEffect(() => {
        // Don't redirect until auth state is fully hydrated
        if (!auth.hydrated) {
            return;
        }
        
        if (!isAuthenticated(auth)) {
            history.push('/');
            return;
        }
    }, [auth, history]);

    // Don't render until auth check is complete and hydrated
    if (!auth.hydrated || !isAuthenticated(auth)) {
        return (
            <>
                <div className="pt-5">    
                    <Row className="primary-font-color" style={{ paddingTop:"50px", paddingBottom: "20px", overflow:"hidden" }}>
                        <Col xs={1}></Col>
                        <Col xs={10}>       
                                
                                                {/* Page Header - Loading State */}
                        <Row style={{ marginBottom: "32px" }}>
                            <Col xs={12}>
                                <h1 style={{ 
                                    color: "#FFFFFF", 
                                    fontSize: "28px", 
                                    fontWeight: "700",
                                    margin: 0
                                }}>
                                    💬 CONTACT - Loading
                                </h1>
                            </Col>
                        </Row>                        
                            <Row className="mt-4" style={{fontSize:"0.9rem"}}>
                                <Col xs={12}>                                
                                    Please wait while we load the contact information...
                                </Col>
                            </Row>
                            
                        </Col>                            
                    </Row>
                </div>
            </>
        );
    }

    const handleDiscordClick = () => {
        // Open Discord invite link in new tab
        const discordLink = appConfig.social?.discord;
        window.open(discordLink, '_blank');
    };

    return (
        <>
            <div className="pt-5">    
                <Row className="primary-font-color" style={{ paddingTop:"50px", paddingBottom: "20px", overflow:"hidden" }}>
                    <Col xs={1}></Col>
                    <Col xs={10}>       
                            
                                            {/* Page Header */}
                        <Row style={{ marginBottom: "32px" }}>
                            <Col xs={12}>
                                <h1 style={{ 
                                    color: "#FFFFFF", 
                                    fontSize: "28px", 
                                    fontWeight: "700",
                                    margin: 0
                                }}>
                                    💬 CONTACT
                                </h1>
                            </Col>
                        </Row>                        
                        {/* Immediate Help (Discord) Card */}
                        <Row style={{ marginBottom: "24px" }}>
                            <Col xs={12}>
                                <Card style={{
                                    background: "rgba(30, 41, 59, 0.95)",
                                    backdropFilter: "blur(20px)",
                                    border: "1px solid rgba(255, 255, 255, 0.4)",
                                    borderRadius: "16px",
                                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)"
                                }}>
                                    <Card.Body style={{ padding: "24px" }}>
                                        <div style={{ marginBottom: "16px" }}>
                                            <h3 style={{
                                                color: "#FFFFFF",
                                                fontSize: "18px",
                                                fontWeight: "600",
                                                marginBottom: "8px"
                                            }}>
                                                ⚡ IMMEDIATE HELP
                                            </h3>
                                            <p style={{
                                                color: "#E0E0E0",
                                                fontSize: "16px",
                                                margin: 0
                                            }}>
                                                Join our Discord community for instant support and to chat with the founder!
                                            </p>
                                        </div>
                                        <Button 
                                            onClick={handleDiscordClick}
                                            style={{
                                                backgroundColor: "#5865F2",
                                                borderColor: "#5865F2",
                                                color: "#FFFFFF",
                                                fontSize: "16px",
                                                fontWeight: "600",
                                                padding: "12px 24px",
                                                borderRadius: "8px",
                                                border: "none",
                                                transition: "all 0.2s ease-in-out"
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = "#4752C4";
                                                e.target.style.transform = "translateY(-1px)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = "#5865F2";
                                                e.target.style.transform = "translateY(0)";
                                            }}
                                        >
                                            <i className="bi bi-discord me-2"></i>
                                            Join Discord
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {/* Email Support Card */}
                        <Row>
                            <Col xs={12}>
                                <Card style={{
                                    background: "rgba(30, 41, 59, 0.95)",
                                    backdropFilter: "blur(20px)",
                                    border: "1px solid rgba(255, 255, 255, 0.4)",
                                    borderRadius: "16px",
                                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)"
                                }}>
                                    <Card.Body style={{ padding: "24px" }}>
                                        <div style={{ marginBottom: "16px" }}>
                                            <h3 style={{
                                                color: "#FFFFFF",
                                                fontSize: "18px",
                                                fontWeight: "600",
                                                marginBottom: "8px"
                                            }}>
                                                📧 EMAIL SUPPORT
                                            </h3>
                                            <p style={{
                                                color: "#E0E0E0",
                                                fontSize: "16px",
                                                margin: 0
                                            }}>
                                                We respond within 24 hours during business days.
                                            </p>
                                        </div>
                                        <p style={{
                                            color: "#FFFFFF",
                                            fontSize: "18px",
                                            fontWeight: "500",
                                            margin: "16px 0"
                                        }}>
                                            {appConfig.contact?.primary?.email || 'support@recapvid.com'}
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        
                    </Col>                            
                </Row>
            </div>
        </>
    );
};

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(Contact);
